import {
  OnInit,
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { socialAppSelectors } from 'app/modules/social/state/app';
import { AppState } from 'app/types';
import { Loggable } from 'app/utils/logging/loggable';

@Component({
  selector: 'app-presentation-sound-icon',
  templateUrl: './presentation-sound-icon.component.html',
  styleUrls: ['./presentation-sound-icon.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresentationSoundIconComponent extends Loggable implements OnInit, OnDestroy, OnChanges {
  @Input() public sliderVolumeLevel = 0;
  @Output() public emitClickedToggleMusic = new EventEmitter<boolean>();

  protected isPresentationActive = false;
  protected isHost = false;
  protected currentIcon = '';
  protected currentSliderVolumeLevel = 0;

  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    private store: Store<AppState>,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.store
      .select(socialAppSelectors.isHost)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isHost) => {
        this.isHost = isHost;
        this.changeDetectorRef.markForCheck();
      });

    this.store
      .select(socialAppSelectors.isPresentationActive)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isPresentationActive) => {
        this.isPresentationActive = isPresentationActive;
        this.changeDetectorRef.markForCheck();
      });
  }
  public ngOnChanges(changes: SimpleChanges) {
    if (changes.sliderVolumeLevel) {
      this.currentSliderVolumeLevel = changes.sliderVolumeLevel.currentValue;
      this.currentIcon = this.setIcon(changes.sliderVolumeLevel.currentValue);
    }
  }
  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  private setIcon(volume: number): string {
    let newIcon = 'music_note';
    if (this.isPresentationActive) {
      newIcon = volume === 0 ? 'volume_off' : 'volume_up';
    } else {
      newIcon = volume === 0 ? 'music_off' : 'music_note';
    }
    return newIcon;
  }
  protected parentClickedToggleMusic(): void {
    this.emitClickedToggleMusic.emit(true);
  }

  public get getTooltipText(): string {
    if (this.isPresentationActive) {
      return 'Lower Volume';
    }
    return this.currentSliderVolumeLevel === 0 ? 'Turn on my music' : 'Turn off my music';
  }
}
